import styled from 'styled-components';

import {
  Flex,
  Text,
} from 'web-styled';

export const Item = styled(Flex).attrs({
  width: '100%',
  align: 'center',
  justify: 'space-between',
})`
  border-bottom: 1px solid #e7edf2;
`;

export const AmountWrapper = styled(Flex).attrs({
  align: 'center',
})`
  position: relative;
  width: 120px;
  margin-right: 0 !important;

  input {
    padding-left: 22px;
  }
`;

export const Remove = styled.button`
  color: ${props => props.theme.colors.danger} !important;
  font-size: 14px;
  text-align: center;
  line-height: 16px;
  text-decoration: none !important;
  width: 16px;
  height: 16px;
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  box-shadow: none;
  background: transparent;
  cursor: pointer;
`;

export const ItemValue = styled.div`
  font-size: 14px;
  text-align: center;
  padding: 0 5px;
  min-width: 8px;
  height: 20px;
  border: 1px solid #C4C4C4;
`;
